<template>
  <main>
    <v-container>
      <v-row>
        <v-col class="d-flex align-center py-2 px-4">
          <v-breadcrumbs :items="breadcrumbs" class="px-0 py-0" />
        </v-col>
        <v-col class="d-flex justify-end align-center py-2 px-4">
          <router-link :to="redirectToEditView($route.params.id)" class="mr-4">
            <v-btn color="primary" link depressed>Edit</v-btn>
          </router-link>
          <v-btn
            :loading="checkResourceIsDeleting($route.params.id)"
            color="error"
            link
            depressed
            @click="showDeleteModal()"
            >Delete</v-btn
          >
        </v-col>
      </v-row>
    </v-container>

    <v-container>
      <v-row>
        <v-col>
          <v-card outlined>
            <!-- Tabs -->
            <v-tabs v-model="tab" background-color="primary" dark show-arrows>
              <v-tab>Details</v-tab>
            </v-tabs>

            <!-- Tab Items -->
            <v-tabs-items v-model="tab">
              <v-tab-item :transition="false" :reverse-transition="false">
                <v-list dense>
                  <template v-for="(item, index) in resourceItems">
                    <div :key="index">
                      <v-list-item>
                        <v-list-item-content class="font-weight-medium">{{ item.title }}</v-list-item-content>
                        <v-list-item-content v-if="item.type === 'text'" class="align-end">
                          {{ item.value }}
                        </v-list-item-content>
                        <v-list-item-content v-if="item.type === 'tick'" class="align-end">
                          <tick-or-cross :value="!!item.value" class="justify-start" />
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider v-if="index !== resourceItems.length - 1" />
                    </div>
                  </template>
                </v-list>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <delete-modal
      v-if="deleteModalVisible"
      v-model="deleteModalVisible"
      :is-disabled="isDeleting"
      :is-loading="isDeleting"
      :item="deletingResource"
      :category="resourceType"
      @modal-confirm="onResourceDeleteConfirmed"
      @modal-cancel="onResourceDeleteCancelled"
    />
  </main>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import PermissionsHandler from '@/mixins/permissions-handler'
import ViewResource from '@/mixins/view-resource'
import DeleteResource from '@/mixins/delete-resource'

export default {
  name: 'IcosView',
  mixins: [PermissionsHandler, ViewResource, DeleteResource],
  data() {
    return {
      resourceKey: 'name',
      resourceType: 'Ico',
      resourcePrefix: 'content.icos',
      resourceKeys: [
        { title: 'ID', key: 'id' },
        { title: 'uuid', key: 'uuid' },
        { title: 'Name', key: 'name' },
        { title: 'Symbol', key: 'symbol' },
        { title: 'Description', key: 'description.en' },
        { title: 'Short Description', key: 'short_description.en' },
        { title: 'Logo', key: 'logo' },
        { title: 'Blockchain Type', key: 'blockchain_type' },
        { title: 'Platform', key: 'platform' },
        { title: 'Pre Ico Opening Date', key: 'pre_ico_opening_date' },
        { title: 'Pre Ico Closing Date', key: 'pre_ico_closing_date' },
        { title: 'Ico Opening Date', key: 'ico_opening_date' },
        { title: 'Ico Closing Date', key: 'ico_closing_date' },
        { title: 'Country', key: 'country' },
        { title: 'Website', key: 'website' },
        { title: 'Team', key: 'team.en' },
        { title: 'Advisors', key: 'advisors.en' },
        { title: 'Blog', key: 'blog' },
        { title: 'Facebook', key: 'facebook' },
        { title: 'Twitter', key: 'twitter' },
        { title: 'Linkedin', key: 'linkedin' },
        { title: 'Telegram', key: 'telegram' },
        { title: 'Slack', key: 'slack' },
      ],
    }
  },
  computed: {
    ...mapGetters({
      resource: 'icos/getIco',
    }),
    breadcrumbs() {
      return [
        { text: 'Icos', to: { name: 'content.icos' }, exact: true },
        { text: this.resource.name || 'loading', disabled: true },
      ]
    },
  },
  methods: {
    ...mapActions({
      findResource: 'icos/find',
      deleteResource: 'icos/delete',
    }),
  },
}
</script>
